import { render, staticRenderFns } from "./TepTurnoOdoFinal.vue?vue&type=template&id=63b01060"
import script from "./TepTurnoOdoFinal.vue?vue&type=script&lang=js"
export * from "./TepTurnoOdoFinal.vue?vue&type=script&lang=js"
import style0 from "./TepTurnoOdoFinal.vue?vue&type=style&index=0&id=63b01060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports